module.exports = __webpack_public_path__ + "static/media/balloons512x384.af92e9c9.jp2";